// Single Source of Truth für die in der App angezeigte Versionsnummer.
// Bei jedem Release mitziehen (vgl. CLAUDE.md 7a: zusätzlich Marketing-Hero in
// HomePage.tsx und VersionsverlaufPage.tsx aktualisieren).
// 🚨 Stand 17.08.2026 hing dieser Wert auf 0.0.0.376 fest — 155 Versionen hinter dem Code.
// Der Kunde las in der Seitenleiste seiner laufenden App also eine Nummer aus dem Juli.
// Aufgefallen ist es nur, weil ein Screenshot der Oberfläche gemacht wurde; kein Test und
// kein Build schlagen deswegen an. Mitziehen gehört zu jedem Release (CLAUDE.md 7a).
export const APP_VERSION = '0.0.0.1097';
